import { useMutation, useQuery } from '@tanstack/react-query'

import type { UseQueryResult, UseMutationResult } from '@tanstack/react-query'
import type { IChecklist } from '~/types/checklist'

import { getChecklist, getChecklists, notifyStatusChange } from '~/api/checklists'
import { DEFAULT_ITEMS_PER_PAGE_VALUE } from '~/const'

////////// KEYS //////////
export const checklistsKeys = {
  all: ['checklists'] as const,
  details: (checklistId: string) => [...checklistsKeys.all, 'details', checklistId] as const,
  list: (appId?: string) => [...checklistsKeys.all, 'list', appId] as const,
}

////////// QUERIES //////////
export const useChecklistsListQuery = (
  appId?: string,
  options?: { enabled?: boolean }
): UseQueryResult<IPaginatedResponse<IChecklist>, unknown> => {
  return useQuery({
    enabled: options?.enabled !== false && !!appId,
    queryFn: () => getChecklists({ application_id: appId as string, size: DEFAULT_ITEMS_PER_PAGE_VALUE }),
    queryKey: checklistsKeys.list(appId),
  })
}

export const useChecklistsDetailsQuery = (checklistId?: string): UseQueryResult<IChecklist, unknown> => {
  return useQuery({
    enabled: !!checklistId,
    queryFn: () => getChecklist(checklistId as string),
    queryKey: checklistsKeys.details(checklistId as string),
  })
}

//////// MUTATIONS //////////
export const useNotifyStatusChangeMutation = (): UseMutationResult<
  void,
  unknown,
  {
    checklistId: string
    status: 'done' | 'skipped'
    taskId: string
  },
  unknown
> => {
  return useMutation({ mutationFn: notifyStatusChange })
}
